import React, { Component } from 'react';
import './mainstyle.css'

class MainPoster extends Component {
    render() {
        return (
            <div className="container">
                <br /><br />
                <div className="card-group">
                    <div className="card left-div">
                        <img src={this.props.img} alt="" className="" />
                    </div>
                    <div className="card right-div bg-main container flex-box">
                        <br />
                        <h4 className="text-center text-white">Living in the natural environment will provide us good mental and physical health. So the Thuru.lk website is a complete platform for all Sri Lankan and overseas natural beauty lovers to get all the information regarding how they can implement their garden environment natural look.</h4>
                    </div>
                </div>

            </div>

        );
    }
}

export default MainPoster;
